const noop = () => {};
const fallbackButton = {show: noop, hide: noop, onClick: noop, offClick: noop, setText: noop, showProgress: noop, hideProgress: noop};
const telegram = window.Telegram?.WebApp;
const fallback = {
    initData: '', initDataUnsafe: {}, themeParams: {}, platform: 'browser',
    MainButton: fallbackButton, BackButton: fallbackButton,
    expand: noop, ready: noop, enableClosingConfirmation: noop,
    openLink: url => window.open(url, '_blank', 'noopener,noreferrer'),
    showAlert: message => window.alert(message),
    showConfirm: (message, callback) => callback(window.confirm(message)),
};
export const Config = {
    tgWindow: telegram || fallback,
    user: telegram?.initDataUnsafe?.user || {},
    apiUrl: process.env.REACT_APP_API_URL || 'https://rbychin.ddns.net/cln-v2/api',
    colors: {buttonColor: '#02629a', hintColor: '#9ca7b9'},
    HapticFeedback: Object.fromEntries(['error', 'success', 'warning', 'light', 'medium', 'heavy', 'soft'].map(type => [type, () => {
        const haptic = telegram?.HapticFeedback;
        if (['error', 'success', 'warning'].includes(type)) haptic?.notificationOccurred(type);
        else haptic?.impactOccurred(type);
    }])),
};
export const WebUrls = {
    BASE_URL: '/v2/', UserPage: '/v2/user', LoginPage: '/v2/login',
    AccountPage: '/v2/account', PaymentPage: '/v2/pay', Settings: '/v2/settings',
    ErrorPage: '/v2/error', History: '/v2/history', Support: '/v2/support',
};
